import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'uppercaseSplit'
})
export class UppercaseSplitPipe implements PipeTransform {

  transform(value: string): string {
      return value.split(/(?=[A-Z])/).join(' ');
  }

}
